export default __webpack_public_path__ + "static/media/announcer-round3.624f4180.mp3";